import { configureStore, combineReducers } from "@reduxjs/toolkit";
import userReducer from "./userSlice";
import footerlinkReducer from "./footerlinkSlice";
import resourcesearchReducer from "./resourcesearchSlice";
import notificationReducer from "./notificationSlice";
import quicklinksReducer from "./quicklinkSlice";

import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import sliderReducer from "./sliderSlice";
import midbannerReducer from "./midbannerSlice";
import appReducer from "./appSlice";

const persistConfig = {
  key: "root",
  version: 1,
  storage,
};

const rootReducer = combineReducers({ 
  user: userReducer,
  resourcesearch : resourcesearchReducer,
  footerlink : footerlinkReducer,
  slider : sliderReducer,
  notification : notificationReducer,
  midbanner : midbannerReducer,
  quicklinks : quicklinksReducer,
  app : appReducer
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store)